export const UPDATE_BILLING_ADDRESS = 'UPDATE_BILLING_ADDRESS';
export const UPDATE_BILLING_ADDRESS_FULFILLED = 'UPDATE_BILLING_ADDRESS_FULFILLED';
export const UPDATE_BILLING_ADDRESS_REJECTED = 'UPDATE_BILLING_ADDRESS_REJECTED';
export const CLEAR_BILLING_ADDRESS = 'CLEAR_BILLING_ADDRESS';
